export default "__VITE_PUBLIC_ASSET__ea2fc60f__"